import { isEmpty } from 'lodash';

export const parseFullName = (firstName, lastName) => {
  if (!isEmpty(firstName) && !isEmpty(lastName)) {
    return `${firstName} ${lastName}`;
  }
  return firstName || '';
};
